import { FC, ReactNode, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  setAttemptedRoute,
  setUnsavedDetectorInitiated,
} from "../../store/slices/route-state.slice";
import { isLoggedIn as isAuthenticated } from "../auth/auth.service";
import MfaComponent from "../components/mfa/mfa.component";
import ModalComponent from "../components/modal/modal.component";
import HasPermission from "./has-permission";
import {
  setSelectedBlock,
  setSelectedSiteCode,
  setSelectedTcCode,
} from "src/store/slices/dashboard.slice";

interface Props {
  children: ReactNode;
  moduleName?: string;
  actionName: string;
}

const PrivateRoute: FC<Props> = ({
  children,
  moduleName = null,
  actionName,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(isAuthenticated());
  const [showUnsavedWarningModal, setShowUnsavedWarningModalModal] =
    useState(false);
  const navigate = useNavigate();

  const { pathname } = location;

  useEffect(() => {
    if (!pathname.includes("/dashboard")) {
      dispatch(setSelectedTcCode(null));
      dispatch(setSelectedSiteCode(null));
      dispatch(setSelectedBlock(null));
    }
  }, [pathname, dispatch]);

  const [isOTPModalOpen, setIsOtpModalOpen] = useState<boolean>(false);

  const isOtpVerified = useSelector((state: any) => {
    return state.otp.isOtpVerified;
  });

  const attemptedRoute = useSelector((state: any) => {
    return state.routeState.attemptedRoute;
  });

  const onSubmitMfaOtp = async () => {
    // setToken(localStorage.getItem("temp-token"));
    localStorage.setItem("isLogout", JSON.stringify(false));
    setIsOtpModalOpen(false);

    const currentPathname = pathname;
    window.location.reload();
    navigate(currentPathname);
  };

  const onUnsusavedSubmit = () => {
    setShowUnsavedWarningModalModal(false);
    dispatch(setUnsavedDetectorInitiated(false));
    dispatch(setAttemptedRoute(""));
    navigate(`${attemptedRoute}`);
  };

  const mfaActionConfig: any = [
    {
      label: "Save",
      event: onSubmitMfaOtp,
      variant: "primary",
      disabled: !isOtpVerified,
    },
  ];

  const unsavedActionConfig: any = [
    {
      label: "Yes",
      event: onUnsusavedSubmit,
      variant: "primary",
    },
  ];

  useEffect(() => {
    if (attemptedRoute.length && !showUnsavedWarningModal) {
      setShowUnsavedWarningModalModal(true);
    }
  }, [attemptedRoute]);

  const handleCloseUnsaved = () => {
    setShowUnsavedWarningModalModal(false);
    dispatch(setAttemptedRoute(""));
  };

  return (
    <>
      {isLoggedIn ? (
        <>
          {moduleName ? (
            <>
              <HasPermission
                moduleName={moduleName}
                actionName={actionName}
                isRoute={true}
              >
                {children}
              </HasPermission>
            </>
          ) : (
            <>{children}</>
          )}
        </>
      ) : (
        <Navigate to={"/login"} />
      )}

      {isOTPModalOpen && (
        <ModalComponent
          showModal={isOTPModalOpen}
          actionConfig={mfaActionConfig}
          headerTitle={"Multi Factor Authentication"}
          isViewMode={true}
          backdropClassName="custom-backdrop"
          isClosable={false}
        >
          <MfaComponent />
        </ModalComponent>
      )}

      <ModalComponent
        isConformationModal={true}
        showModal={showUnsavedWarningModal && attemptedRoute.length}
        actionConfig={unsavedActionConfig}
        headerTitle={"Unsaved Changes"}
        isViewMode={true}
        backdropClassName="custom-backdrop"
        isClosable={false}
        handleClose={handleCloseUnsaved}
      >
        <h5 className="text-center">
          Are you sure to <b className="text-danger">Discard Changes</b>?
        </h5>
      </ModalComponent>
    </>
  );
};

export default PrivateRoute;
